export function getObjectName(
  object: {
    name: string | null | undefined;
    streetAddress: string | null | undefined;
    zip: string | null | undefined;
    city: string | null | undefined;
  } | null,
  showLongName: boolean = false
): string {
  if (object == null) {
    return '---';
  }

  let name: string | null = null;

  if (object.streetAddress) {
    if (object.zip && object.city) {
      name = object.streetAddress + ', ' + object.zip + ' ' + object.city;
    } else if (object.city) {
      name = object.streetAddress + ', ' + object.city;
    } else {
      name = object.streetAddress;
    }
  } else if (object.city) {
    if (object.zip) {
      name = object.zip + ' ' + object.city;
    } else {
      name = object.city;
    }
  } else if (object.zip) {
    name = object.zip;
  }

  if (object.name) {
    if (!showLongName || !name) {
      name = object.name;
    } else {
      name = object.name + ', ' + name;
    }
  }

  if (!name) {
    return '---';
  } else {
    return name;
  }
}

export function getAddressString(
  object: {
    streetAddress: string | null | undefined;
    zip: string | null | undefined;
    city: string | null | undefined;
  } | null
): string {
  if (object == null) {
    return '';
  }
  return (
    (object.streetAddress ? object.streetAddress : '') +
    (object.streetAddress && (object.zip || object.city) ? ',' : '') +
    (object.zip ? ' ' + object.zip : '') +
    (object.city ? ' ' + object.city : '')
  );
}
